import { render } from "./HomeRestaurants.vue?vue&type=template&id=33d465a0&scoped=true"
import script from "./HomeRestaurants.vue?vue&type=script&lang=js"
export * from "./HomeRestaurants.vue?vue&type=script&lang=js"

import "./HomeRestaurants.vue?vue&type=style&index=0&id=33d465a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d465a0"]])

export default __exports__